/**
 * Si el id ya existe en el array, lo elimina, si no, lo agrega
 * @param {Array<number|string>} arrayIds - Array de ids
 * @param {number|string|null} id - Id a agregar o eliminar
 * @returns {Array<number|string>} Array con el id agregado o eliminado
 */
export const toggleIdInArray = (arrayIds = [], id) => {
  if (!id && id !== 0) return arrayIds
  return arrayIds.includes(id)
    ? arrayIds.filter(currentId => currentId !== id)
    : [...arrayIds, id]
}